import { Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'vds-teaser-small',
  styleUrl: 'vds-teaser-small.scss',
  shadow: true,
})
export class VdsTeaserSmall {

  /**
   * Sets the headline of the component
   * Mandatory: yes
   * Max Chars: 50
   */
  @Prop() headline = '';

  /**
   * Subline displayed underneath the headline
   * Mandatory: no
   */
  @Prop() subline = '';

  /**
   * Text content displayed above the call to action slot
   */
  @Prop() copy = '';

  /**
   * Sets the position of the media slot
   */
  @Prop() mediaPosition: 'left' | 'right' = 'left';

  render() {
    if(this.mediaPosition == "left") {
      return (
        <Host>
          <div class="relative bg-white flex flex-wrap box-border border-2 border-grey-lighter border-b-8 border-b-yellow rounded-[5px]">
            <div class="box-border sm:w-6/12 lg:w-4/12 sm:py-[50px] sm:pl-[50px] pr-0">
              <slot name="media"></slot>
            </div>
            <div class="sm:w-6/12 lg:w-8/12 p-[50px] bg-[length:57%] bg-[-45%_0] bg-no-repeat">
              <h2 class="font-heavy text-h2-mobile sm:text-h2-tablet lg:text-h2-desktop text-grey uppercase break-words" innerHTML={this.headline}></h2>
              <h3 class="font-regular text-s2-mobile sm:text-s2-tablet lg:text-s2-desktop text-berry uppercase mt-2 break-words" innerHTML={this.subline}></h3>
              <p class="font-regular text-base-mobile sm:text-base-tablet lg:text-base-desktop text-grey my-7" innerHTML={this.copy}></p>
              <slot name="cta"></slot>
            </div>
          </div>
        </Host>
      );
    }
    else if(this.mediaPosition == "right") {
      return (
        <Host>
          <div class="relative bg-white flex flex-wrap box-border border-2 border-grey-lighter border-b-8 border-b-yellow rounded-[5px]">
            <div class="sm:w-6/12 lg:w-8/12 p-[50px] bg-[length:57%] bg-[-45%_0] bg-no-repeat">
              <h2 class="font-heavy text-h2-mobile sm:text-h2-tablet lg:text-h2-desktop text-grey uppercase break-words" innerHTML={this.headline}></h2>
              <h3 class="font-regular text-s2-mobile sm:text-s2-tablet lg:text-s2-desktop text-berry uppercase mt-2 break-words" innerHTML={this.subline}></h3>
              <p class="font-regular text-base-mobile sm:text-base-tablet lg:text-base-desktop text-grey my-7" innerHTML={this.copy}></p>
              <slot name="cta"></slot>
            </div>
            <div class="box-border sm:w-6/12 lg:w-4/12 sm:py-[50px] sm:pr-[50px] pr-0">
              <slot name="media"></slot>
            </div>
          </div>
        </Host>
      );
    }
  }

}
